var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 18.3527L15.4479 14.6005C16.4225 13.4085 16.9017 11.8874 16.7864 10.3519C16.671 8.81645 15.9699 7.38406 14.828 6.35104C13.6862 5.31801 12.191 4.76338 10.6516 4.80186C9.11232 4.84035 7.64668 5.46901 6.55788 6.55782C5.46908 7.64662 4.84041 9.11226 4.80193 10.6516C4.76344 12.1909 5.31807 13.6861 6.3511 14.828C7.38413 15.9698 8.81652 16.6709 10.352 16.7863C11.8875 16.9017 13.4085 16.4225 14.6006 15.4478L18.3528 19.2L19.2 18.3527ZM10.8112 15.6048C9.86315 15.6048 8.93636 15.3236 8.14805 14.7969C7.35975 14.2702 6.74534 13.5215 6.38252 12.6456C6.0197 11.7697 5.92478 10.8059 6.10974 9.87599C6.2947 8.94612 6.75125 8.09198 7.42164 7.42158C8.09204 6.75119 8.94618 6.29464 9.87605 6.10968C10.8059 5.92471 11.7698 6.01964 12.6457 6.38246C13.5216 6.74528 14.2702 7.35969 14.797 8.14799C15.3237 8.9363 15.6048 9.86309 15.6048 10.8112C15.6034 12.0821 15.0979 13.3005 14.1993 14.1992C13.3006 15.0979 12.0821 15.6034 10.8112 15.6048Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.09738337419936753519d0aaa00d7980.svg";
export { ForwardRef as ReactComponent };